import { cloneElement, type ReactElement } from 'react'

import Icon, { type IconPropsType } from '@/legacy-src/components/icons/Icon'
import { cn } from '@/legacy-src/lib/utils'

import type { AppointmentType } from '@/src/domains/appointments/types'

const iconMap: Record<AppointmentType, ReactElement<IconPropsType>> = {
  [0]: <Icon icon="video" />,
  [1]: <Icon icon="location" />,
  [2]: <Icon icon="hybrid" />,
}

export interface AppointmentTypeIconProps extends Pick<IconPropsType, 'className' | 'color'> {
  type: AppointmentType
}

export const AppointmentTypeIcon = ({ type, className, color }: AppointmentTypeIconProps) =>
  cloneElement(iconMap[type], {
    size: 'native',
    width: 24,
    height: 24,
    className: cn(className, 'shrink-0'),
    color,
  })
